/**
 * mock data for dev mode
 */

module.exports = {
  products: [
    {
      pid: 7217723,
      itemName: 'Apple iPhone SE (2020) 64GB 手機',
      saleDesc: '13499',
      img: '//img.shopping.friday.tw/images/product/240/7217723/7217723_3_1.jpg?969648'
    }
  ]
}
